// Toggles the sticky mobile Buy Now bar (#hb-bn-two) based on whether the
// inline Buy Now button (#hb-bn-one) is currently visible in the viewport —
// same pattern as the Shiprocket sr_one/sr_two toggle.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var inlineBtn = document.getElementById('hb-bn-one');
    var stickyBtn = document.getElementById('hb-bn-two');
    if (!inlineBtn || !stickyBtn || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBtn.style.display = entry.isIntersecting ? 'none' : 'block';
        });
      },
      { root: null, threshold: 0 }
    );

    observer.observe(inlineBtn);
  });
})();
